<app-model-pj-view fxFlex="100"></app-model-pj-view>
